import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface RoleFormCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

/** Ask the user before leaving a dirty role form. */
export const roleFormCanDeactivateGuard: CanDeactivateFn<RoleFormCanDeactivate> = (component) => {
  return component.canDeactivate();
};
